var version = {
    "name":      "dativery",
    "buildDateCode": "20242724-180737",
    "buildDate": "Wed Jul 24 2024 18:27:37 GMT+0000 (Coordinated Universal Time)",
    "version":   "2.2.0",
    "uiVersion": "2.2.0-20242724-180737"
}
;
 export default version;